import classnames from 'classnames';

import { Loader } from '../Loader';

import { ModalCloseIcon } from './ModalCloseIcon';
import styles from './ModalStack.module.scss';
import { ModalProps } from './types';

export const ModalHeader = ({ title, onDismiss, hideCloseButton }: ModalProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>{title}</div>
      {!hideCloseButton && <ModalCloseIcon onDismiss={onDismiss} />}
    </div>
  );
};

export const ModalContent = ({
  children,
  className,
  innerClassName,
  isLoading,
  wrapped = true,
  ...props
}: React.ComponentProps<'div'> & { innerClassName?: string; isLoading?: boolean; wrapped?: boolean }) => {
  return (
    <div className={classnames(styles.body, className)} {...props}>
      {isLoading && (
        <div className={classnames(styles.overlay)} role="status">
          <Loader size={30} strokeSize={2} isRelative />
        </div>
      )}
      {!isLoading && wrapped && <div className={classnames(styles.inner, innerClassName)}>{children}</div>}
      {!isLoading && !wrapped && children}
    </div>
  );
};

export const ModalFooter = ({ children, className }: React.ComponentProps<'div'>) => {
  return <div className={classnames(styles.footer, className)}>{children}</div>;
};
